import { Box, IconButton, Link, Modal } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React, { useEffect, useState } from "react";

import { ReactComponent as Warning } from "assets/warning-red.svg";
import { Button, Paragraph, StyledGrid } from "components/simple";
import { color, spacingDefaults } from "style/constants";

interface TokenExpirationModalProps {
  show: boolean;
  expirationTime: number;
  onAccept: () => void;
}

const TokenExpirationModal: React.FC<TokenExpirationModalProps> = ({
  show,
  expirationTime,
  onAccept
}: TokenExpirationModalProps): JSX.Element => {
  const [timeRemaining, setTimeRemaining] = useState(0);

  useEffect(() => {
    const handle = setInterval(() => {
      setTimeRemaining(Math.max(0, expirationTime - Math.floor(new Date().getTime() / 1000)));
    }, 1000);

    return () => clearInterval(handle);
  }, [expirationTime]);

  return (
    <Modal open={show}>
      <StyledGrid
        alignItems="center"
        backgroundColor={color.WHITE}
        border={`1px solid ${color.MUTEDGRAY}`}
        borderRadius="8px"
        container
        direction="column"
        left="50%"
        padding={`${spacingDefaults.normal} 0`}
        position="absolute"
        top="50%"
        transform="translateX(-50%) translateY(-50%)"
        width="475px"
      >
        <StyledGrid item>
          <Warning width={150} height={150} />
        </StyledGrid>

        <StyledGrid item textAlign="center" marginBottom={spacingDefaults.normal}>
          Your session is going to expire in:
          <Box marginY={spacingDefaults.small}>
            <strong>
              {Math.floor(timeRemaining / 60)} minute(s) {timeRemaining % 60} second(s)
            </strong>
          </Box>
          You can renew your session by clicking Continue below.
        </StyledGrid>

        <StyledGrid item marginTop={spacingDefaults.normal} marginBottom={spacingDefaults.xsmall}>
          <Button onClick={onAccept}>Continue</Button>
        </StyledGrid>
      </StyledGrid>
    </Modal>
  );
};

export default TokenExpirationModal;
